import React from "react";
import UserService from "../../services/UserService";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) =>
				UserService.get() ? <Component {...props} /> : <Redirect to="/login" />
			}
		/>
	);
};

export default ProtectedRoute;
